import React, { createContext, useContext } from 'react';

interface BaseDialogProps {
  open: boolean;
  onClose: () => void;
}

export type DialogComponent = React.ComponentType<BaseDialogProps>;

export interface DialogState {
  open: boolean;
  component?: DialogComponent;
  props?: Record<string, unknown>;
}

export interface DialogContextType {
  dialogState: DialogState;
  open: (Component: DialogComponent, props?: Record<string, unknown>) => void;
  close: () => void;
}

export const DialogContext = createContext<DialogContextType | undefined>(
  undefined
);

export function useDialogs() {
  const context = useContext(DialogContext);
  if (context === undefined) {
    throw new Error('useDialogs must be used within a DialogsProvider');
  }
  return context;
}
